import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import es from "./locales/es.json";
import en from "./locales/en.json";
import it from "./locales/it.json";

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: { es: { translation: es }, en: { translation: en }, it: { translation: it } },
        fallbackLng: "es",
        supportedLngs: ["es", "en", "it"],
        nonExplicitSupportedLngs: true,
        load: "languageOnly",
        interpolation: { escapeValue: false },
        detection: {
            order: ["localStorage"],
            caches: ["localStorage"],
            lookupLocalStorage: "av_lang_v1",
        },
        returnNull: false,
    });

export default i18n;
